// extracted by mini-css-extract-plugin
export default {"summary":"TaskMemberPage_summary__UtDca","title":"TaskMemberPage_title__hwxfz"};